export default __webpack_public_path__ + "static/media/certificacion_intermedia.0e85075e.svg";